import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_TRADING_ENGINE + "version/";

export async function getVersion() {
  const { data: version } = await http.get(apiEndpoint);
  return version;
}
